import { createAsyncThunk, createSlice, createAction } from '@reduxjs/toolkit'
import axios from 'axios'

import { $post } from '../../../../../utils/apis'
import { LOADING } from '../../../../../utils/constants'
import { updateStateAction } from '../../../../../utils/fns'

const getHangersData = createAsyncThunk(
  'request/hangers',
  async (body, { rejectWithValue, signal }) => {
    const source = axios.CancelToken.source()

    signal.addEventListener('abort', () => {
      source.cancel()
    })

    try {
      const response = await $post('/hanger-selector/hangers', body, { cancelToken: source.token })
      return response.data
    } catch (err) {
      return rejectWithValue(err.response.data)
    }
  },
)

const productOrderAction = createAction('result/productOrderAction', function (payload) {
  return {
    payload,
  }
})

export const resultSlice = createSlice({
  name: 'result',
  initialState: {
    loading: LOADING.PENDING,
    data: [],
    renderedData: [],
    query: '',
    warning: '',
    optimized: true,
    searchKeyword: '',
    selectedRow: null,
    sortBy: [{ id: 'ici', desc: false }],
  },
  reducers: {
    createOutputQuery: (state, action) => {
      state.query = action.payload
    },
    setOptimized: (state) => {
      state.optimized = !state.optimized
    },
    setSearchKeyword: (state, action) => {
      state.searchKeyword = action.payload
    },
    setSelectedRow: (state, action) => {
      state.selectedRow = action.payload
    },
    setRenderedData: (state, action) => {
      state.renderedData = action.payload
    },
    updateInput: updateStateAction,
    updateCalculation: updateStateAction,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHangersData.pending, (state) => {
        state.loading = LOADING.PENDING
        state.error = ''
        state.renderedData = []
      })
      .addCase(getHangersData.fulfilled, (state, action) => {
        const result = action.payload

        state.loading = LOADING.SUCCEEDED
        state.data = result.lstHangerOutput ?? []
        state.error = ''
      })
      .addCase(getHangersData.rejected, (state, action) => {
        if (action.meta.aborted) {
          return
        }

        state.loading = LOADING.FAILED
        state.error =
          'The network connection is currently unavailable to generate results. Please try your calculations again at a later time.'
        state.data = []
      })
  },
})

export const resultActions = { ...resultSlice.actions, getHangersData, productOrderAction }
